/**
 * Written by the backend in place of a file when an adoption carries no document: an adoption
 * settled from a payment link, or one whose papers were handled outside Petso. It is a marker, not
 * a file, so nothing can be opened or downloaded from it and the UI must not present it as added.
 */
export const NOT_PROVIDED_FILE_KEY = 'NOT_PROVIDED.pdf'

/** Whether a real document was provided, as opposed to the placeholder above or nothing at all. */
export const hasProvidedDocument = (...fileKeys: Array<string | undefined | null>): boolean =>
  fileKeys.some((fileKey) => Boolean(fileKey) && fileKey !== NOT_PROVIDED_FILE_KEY)
